module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n    <select data-file-column=\"")
    ; __append(escapeFn( fileColumn ))
    ; __append("\" on-change=\"onCoordinateFormatChange\">\n        <option value=\"dd\">Десятичные градусы</option>\n        <option value=\"dms\">Градусы, минуты, секунды</option>\n    </select>\n</div>")
  }
  return __output.join("");

}